import { createPluginFactory } from '@udecode/plate-core';
import { ImagePlugin } from './types';
import { withImageUpload } from './withImageUpload';

export const ELEMENT_IMAGE = 'img';

/**
 * Enables support for images.
 */
export const createImagePlugin = createPluginFactory<ImagePlugin>({
  key: ELEMENT_IMAGE,
  isElement: true,
  isVoid: true,
  withOverrides: withImageUpload,
  then: (editor, { type }) => ({
    deserializeHtml: {
      getNode: (el) => ({
        type,
        url: el.getAttribute('src'),
      }),
      validNodeName: 'IMG',
    },
  }),
});
